import AboutFour from "../Components/About/AboutFour";
import AboutOne from "../Components/About/AboutOne";
import BlogOne from "../Components/Blog/BlogOne";
import BrandCarouselOne from "../Components/Brands/BrandCarouselOne";
import CtaOne from "../Components/Cta/CtaOne";
import CtaThree from "../Components/Cta/CtaThree";
import PlansTwo from "../Components/Cta/PlansTwo";
import FaqOne from "../Components/Faq/FaqOne";
import FeaturesOne from "../Components/Features/FeaturesOne";
import FooterOne from "../Components/Footer/FooterOne";
import HeaderOne from "../Components/Header/HeaderOne";
import HeaderTwo from "../Components/Header/HeaderTwo";
import HeroFive from "../Components/Hero/Herofive";
import HeroOne from "../Components/Hero/HeroOne";
import HeroSocials from "../Components/Hero/HeroSocials";
import PortfolioOne from "../Components/Portfolio/PortfolioOne";
import Plans from "../Components/Price/Plans";
import ServicesOne from "../Components/Services/ServicesOne";
import ServicesTwo from "../Components/Services/ServicesTwo";
import TeamOne from "../Components/Team/TeamOne";
import TestimonialOne from "../Components/Testimonial/TestimonialOne";
import WorkProcess from "../Components/Work/WorkProcess";
import PlanPage from "./PlanPage";
const LandingPage = () => {
    return (
        <>
            <HeaderTwo />
            {/* <HeroSocials/> */}
            <div id="home"><HeroFive /></div>
            <div id="services"><ServicesTwo /></div>
            <div id="why-choose-us"><AboutFour /></div>
            {/* <ServicesOne/>
        <CtaOne/>
        <FeaturesOne/> */}

            <TestimonialOne />
            {/* <Plans/> */}
            <div id="amc-packages"><PlansTwo /></div>

            {/* <PortfolioOne/>
        <BrandCarouselOne/> */}
            {/* <TeamOne/>
        <FaqOne/> */}
            {/* <BlogOne/> */}
            <FooterOne />

            {/* Floating Sticky Buttons */}
            <div className="floating-action-btns">
                <a
                    href="https://wa.me/971502033924"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="fab-btn fab-whatsapp"
                    aria-label="WhatsApp"
                    style={{ color: '#fff' }}
                >
                    <i className="fab fa-whatsapp"></i>
                </a>
                <a
                    href="tel:+971502033924"
                    className="fab-btn fab-call"
                    aria-label="Call Now"
                    style={{ color: '#fff' }}
                >
                    <i className="fas fa-phone"></i>
                </a>
            </div>
        </>
    )
}

export default LandingPage;